import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import { t } from 'i18next';
import { isNil } from 'lodash-es';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { JobInvoicing } from '~hooks/useJob/models';

interface LoadsColumnProps {
  job: JobInvoicing;
  sx?: SxProps<Theme>;
}

export default function LoadsColumn({ job, sx }: LoadsColumnProps) {
  const { loadsCount } = job;
  const completedLoadsCount = job.jobSummary?.completedLoadsCount;

  const isMissingValues = isNil(loadsCount) || isNil(completedLoadsCount);

  if (isMissingValues) {
    return null;
  }

  return (
    <Box sx={sx}>
      <OverflowAwareText
        sx={{ fontWeight: 700 }}
      >{`${completedLoadsCount} ${t('common.completed')}`}</OverflowAwareText>
      <OverflowAwareText>{`${loadsCount} ${t('dispatch.order.loads')}`}</OverflowAwareText>
    </Box>
  );
}
